export default {
    templates: [],
    saveTemplateStatus: false,
    matchingTemplates: [],
    loadTemplateStatus: false,
    editTemplateStatus: false,
    searchQueries: [],
    saveQueryStatus: false,
    matchingQueries: [],
    loadQueryStatus: false,
    editQueryStatus: false,
    templatesSearchquery: [],
    editQuerySearchStatus: false
  }
